import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BackComponent } from '../../../../shared/components/back/back.component';
import { ContactFormComponent } from '../../../../shared/components/contact-form/contact-form.component';
@Component({
  selector: 'app-contact-us',
  imports: [TranslateModule, BackComponent, ContactFormComponent],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.css',
})
export class ContactUsComponent {}
